
import { isObject } from 'vessel/utils'

export default {
  name: 'VsSeparator',
  props: {
    image: {
      type: [String, Object],
      default: null
    },
    color: {
      type: String,
      default: 'grey-light'
    }
  },
  vessel: {
    line: {
      borderBottomWidth: 1,
      $color: 'borderColor'
    }
  },
  computed: {
    imageAttrs() {
      const defaults = {
        width: 'md',
        fit:   'contain',
        ratio: 'square'
      }

      const custom = isObject(this.image)
        ? this.image
        : { source: this.image }

      return { ...defaults, ...custom }
    }
  }
}
